import React from 'react';
import PropTypes from 'prop-types';


export default class Wizard extends React.Component {

  static contextTypes = {
    router: PropTypes.shape({
      replace: PropTypes.func.isRequired,
      push: PropTypes.func.isRequired
    }).isRequired
  };

  componentDidMount() {
    this.handleQuery();
  }

  componentDidUpdate() {
    this.handleQuery();
  }

  handleQuery() {
    const {location: {
      pathname,
      query}} = this.props;
    if (pathname === '/wizard/reference') {
      return null;
    }

    if (!query || !('load' in query)) {
      this.context.router.push({
        pathname: '/wizard/reference',
        query: null,
      });
      return null;
    }
  }

  render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/wizard.js